import { type FC } from 'react';
import { HStack, IconArrowRight, Text } from '@direct-frontend/components';
import { type TestProps } from '@direct-frontend/components/testing';
import styles from './SizeTable.module.css';

interface SizeTableButtonProps extends TestProps {
    openModal: VoidFunction;
}

export const SizeTableButton: FC<SizeTableButtonProps> = ({
    'data-testid': dataTestId = 'SizeTableButton',
    openModal,
}) => (
    <button data-testid={dataTestId} className={styles.button} onClick={openModal}>
        <HStack as="span" alignItems="center">
            <Text size="mc">Таблица размеров</Text>

            <Text>
                <IconArrowRight />
            </Text>
        </HStack>
    </button>
);
